import { Outlet } from 'react-router-dom';

function Sites() {
    return (
        <Outlet />
    );
}

export default Sites;